import { darken, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  tableWrapper: {
    overflow: "auto",
    width: "100%",
    margin: "10px 0",
  },
  resultTable: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: 650,
    "& th, & td": {
      padding: "10px",
      border: "1px solid #ccc",
      textAlign: "left",
    },
    "& tr.clickable-row:hover": {
      backgroundColor: "rgba(217, 212, 212, 0.178)",
      cursor: "pointer",
      border: "1px solid rgba(0, 96, 149, 0.5)",
    },
  },
  thHeader: {
    backgroundColor: theme.palette.header,
    color: theme.palette.amano.base.main,
    fontWeight: "bold",
  },
  radioCell: {
    width: 60,
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      width: 50,
    },
  },
  radio: {
    padding: theme.spacing(0.5),
  },
  noResults: {
    marginTop: 50,
    textAlign: "center",
    width: "98%",
    "& .no-results-text": {
      border: "1px solid",
      borderColor: darken(theme.palette.amano.warnings.fire, 0.3),
      padding: "8px 92px 8px 92px",
      backgroundColor: theme.palette.background.paper,
      fontSize: "14pt",
      fontStyle: "italic",
      fontWeight: "bold",
      color: darken(theme.palette.amano.warnings.fire, 0.2),
      opacity: 0.7,
      borderRadius: 3,
      boxShadow:
        "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
    },
  },
}));
